import { createSlice } from '@reduxjs/toolkit';
import { CHART_TYPE } from '../data/constants';

const initialState = {
  loading: false,
  //   pendingOrders: {
  //     error: {
  //       isError: false,
  //       message: '',
  //     },
  //     items: [],
  //   },
  dashboardCount: {
    error: {
      isError: false,
      message: '',
    },
    items: [],
    loading: false,
  },
  chartData: {
    orderStatusAnalytics: {
      data: [],
      isLoading: true,
      error: false,
    },
    sales: {
      data: [],
      isLoading: true,
      error: false,
    },
    orderDataAnalytics: {
      data: [],
      isLoading: true,
      error: false,
    },
    proposalData: {
      data: [],
      isLoading: true,
      error: false,
    }
  }
};

export const dashboardSlice = createSlice({
  name: 'dashboardCounting',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setDashboardLoading: (state, action) => {
      state.dashboardCount.loading = action.payload;
    },
    setDashboardCount: (state, action) => {
      state.dashboardCount.items = action.payload;
      state.dashboardCount.error = {
        isError: false,
        message: '',
      };
    },
    setDashboardCountError: (state, action) => {
      state.dashboardCount.items = [];
      state.dashboardCount.error = action.payload;
    },
    setChartLoader: (state, action) => {
      const chartType = action.payload.chartType;
      const isLoading = action.payload.isLoading;
      if (chartType === CHART_TYPE.orderStatus) {
        state.chartData.orderStatusAnalytics.isLoading = isLoading;
      } else if (chartType === CHART_TYPE.orderData) {
        state.chartData.orderDataAnalytics.isLoading = isLoading;
      } else if (chartType === CHART_TYPE.sales) {
        state.chartData.sales.isLoading = isLoading;
      } else if (chartType === CHART_TYPE.proposalData) {
        state.chartData.proposalData.isLoading = isLoading;
      }
    },
    setChartData: (state, action) => {
      const chartType = action.payload.chartType;
      const chartData = action.payload.chartData;

      if (chartType === CHART_TYPE.orderStatus) {
        state.chartData.orderStatusAnalytics.data = chartData;
        state.chartData.orderStatusAnalytics.isLoading = false;
      } else if (chartType === CHART_TYPE.orderData) {
        state.chartData.orderDataAnalytics.data = chartData;
        state.chartData.orderDataAnalytics.isLoading = false;
      } else if (chartType === CHART_TYPE.sales) {
        state.chartData.sales.data = chartData;
        state.chartData.sales.isLoading = false;
      } else if (chartType === CHART_TYPE.proposalData) {
        state.chartData.proposalData.data = chartData;
        state.chartData.proposalData.isLoading = false;
      }
    },
    setChartError: (state, action) => {
      const chartType = action.payload.chartType;

      if (chartType === CHART_TYPE.orderStatus) {
        state.chartData.orderStatusAnalytics.error = true;
        state.chartData.orderStatusAnalytics.isLoading = false;
      } else if (chartType === CHART_TYPE.orderData) {
        state.chartData.orderDataAnalytics.error = true;
        state.chartData.orderDataAnalytics.isLoading = false;
      } else if (chartType === CHART_TYPE.sales) {
        state.chartData.sales.error = true;
        state.chartData.orderDataAnalytics.isLoading = false;
      } else if (chartType === CHART_TYPE.proposalData) {
        state.chartData.proposalData.error = true;
        state.chartData.proposalData.isLoading = false;
      }
    },
  },
});

export default dashboardSlice.reducer;

// Action creators are generated for each case reducer function
export const { setLoading, setDashboardCount, setDashboardCountError, setDashboardLoading, setChartLoader, setChartData, setChartError } =
  dashboardSlice.actions;

export const dashboardItemsSelector = (state) => state.dashboardCount;
